import React from 'react'
import { Link, Text } from '@sketch/components'
import {
  Description,
  FootNote,
  QuestionMarkIcon,
  Section,
  Title,
  Divider,
} from './WorkspaceSettingsIntegrations.styles'
import { SKETCH_WEBSITE } from '@sketch/env-config'
import { WorkspaceIntegrations } from '../../components/WorkspaceIntegrations'
import { useIntegrationsURLHandler } from '../../hooks'

export interface WorkspaceSettingsIntegrationsProps {
  workspaceId: string
}

export const WorkspaceSettingsIntegrations: React.FC<
  WorkspaceSettingsIntegrationsProps
> = ({ workspaceId }) => {
  useIntegrationsURLHandler({ workspaceId })

  return (
    <Section>
      <Title>Integrations</Title>
      <Description>
        Integrations connect your workspace directly to external apps and
        services.{' '}
        <Link href={`${SKETCH_WEBSITE}/redirect/web/integrations`} external>
          Learn More ↗
        </Link>
      </Description>

      <WorkspaceIntegrations workspaceId={workspaceId} />
      <Divider />

      <FootNote>
        <div>
          <QuestionMarkIcon />
        </div>
        <Text textStyle="copy.tertiary.standard.D">
          <strong>
            Missing an integration?{' '}
            <Link href="https://www.sketch.com/support/contact/" external>
              Let us know
            </Link>
          </strong>{' '}
          which apps and services you’d like to see us integrate with.
        </Text>
      </FootNote>
    </Section>
  )
}
